const state = {
    scrollCalled: false
}

const getters = {}

const actions = {
    async scroll({commit}, payload) {
        // payload example
        // let payload = {
        // 	idLoadMore: "loading-list-transaksi",
        // 	container: "list-transaksi-content",
        // 	pagination: this.pagination,
        // 	callback: this.listTransaksi,
        // }

        if ($('#' + payload.idLoadMore).is(":hidden")) {
            if ($("." + payload.container).is(":visible")) {
                if (payload.pagination.pageNumber <= Math.ceil(payload.pagination.length / payload.pagination.limit)) {
                    if (Math.floor($(window).scrollTop()) > 0 && Math.floor($(window).scrollTop()) >= Math.floor($(document).height() - $(window).height()) - 100) {
                        if (payload.pagination.offset > 0) {
                            if (!state.scrollCalled) {
                                commit("setScrollCalled", true)
                            } else {
                                return
                            }
                            await payload.callback()
                        }
                    }
                }
            }
        }
    }
}

const mutations = {
    setScrollCalled: (state, bool) => {
        state.scrollCalled = bool
    },
}

export default {
    namespaced: true,
    state,
    // getters,
    actions,
    mutations,
}